import React from "react";
import { Button, Typography } from "@mui/material";

const SecondaryButton = ({
  height = 50,
  width = "80%",
  style = {},
  onClick,
  text = "Radiant Button",
  ...props
}) => {
  return (
    <Button
      onClick={onClick}
      variant="contained"
      disableElevation
      sx={{
        width,
        height,
        borderRadius: 3,
        border: "2px solid",
        borderColor: "primary.main",
        backgroundColor: "white",
        color: "primary.main",
        fontWeight: "bold",  // ✅ make text bold
        fontSize: 18,
        textTransform: "none",
        "&:hover": {
          backgroundColor: "primary.main",
          color: "white", // ✅ text color in hover
        },
        ...style,
      }}
      {...props}
    >
      <Typography sx={{ fontWeight: "bold" }}>{text}</Typography> {/* ✅ bold text */}
    </Button>
  );
};

export default SecondaryButton;
